import React from 'react'
import { Form, Select } from 'antd'
import styled from 'styled-components'
import { DEFAULT_REQUIRED_FIELD_MESSAGE } from 'components/Assessments/constants'
import {
  getHelpTextFromQuestionnaireItem,
  getSelectOptionsFromQuestionnaireItem
} from 'components/Assessments/helpers'
import { SelectQuestionProps } from '../types'
import LabelAndDescriptionFieldLayout from '../FieldLayout/LabelAndDescriptionFieldLayout'
import QuestionContainer from '../QuestionContainer'

const Container = styled.div`
  margin: 12px 0;
`

function SelectQuestion({
  field,
  formFieldName,
  layout,
  disabled = false,
  required = false,
  customRules = [],
  customOptions,
  placeholder = 'Type or select an option',
  onChange,
  loading = false,
  showSearch = true,
  allowClear = false
}: SelectQuestionProps): JSX.Element {
  // Auto-detect description from field extensions
  const secondaryText = getHelpTextFromQuestionnaireItem(field)

  // Use custom options if provided, otherwise fall back to field answerOptions
  const options = customOptions || getSelectOptionsFromQuestionnaireItem(field) || []

  // Combine default required rule with custom rules
  const allRules = [
    {
      required: Boolean(required && field.required),
      message: DEFAULT_REQUIRED_FIELD_MESSAGE
    },
    ...customRules
  ]

  return (
    <QuestionContainer linkId={field.linkId}>
      <Container>
        <LabelAndDescriptionFieldLayout
          label={field.text}
          secondaryText={secondaryText}
          layout={layout}
        >
          <Form.Item name={formFieldName} rules={allRules} style={{ margin: 0 }}>
            <Select
              disabled={disabled}
              showSearch={showSearch}
              placeholder={placeholder}
              options={options}
              loading={loading}
              onChange={onChange}
              allowClear={allowClear}
            />
          </Form.Item>
        </LabelAndDescriptionFieldLayout>
      </Container>
    </QuestionContainer>
  )
}

export default SelectQuestion
